import sdk from '../../../sdk';
import Logger from '../../../services/Logger';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';
import Toast from '../../../components/Toast';
import TYPES from '../../action-types';
import { showDialog } from '../../../components/dialog';
import { reloadCurrentPage } from '../../../helpers/history';

/**
 * Publish to cdn
 * if id is provided, publish only one asset from preview to cdn
 */
const publishToCdn = (id) => async (dispatch, getAll) => {
  const selectedAssets = id ? [id] : getAll().assets.selectedItems;
  const { selectedAssetsAggregatedData } = getAll().assets;
  try {
    dispatch({ type: TYPES.ASSETS.CDN.PUBLISH.START });

    Toast(localization.TOAST.PUBLISH_CDN_START(selectedAssets.length));

    const { data } = await sdk.assets.publishToCdn({ ids: [...selectedAssets] });
    Logger.log('User', 'InfoPanelPublishToCDN', {
      assets_number: selectedAssets.length,
      publish_to_cdn_count: data.publishedAssets?.length || 0,
    });

    const publishedCount = data.publishedAssets?.length || 0;
    const failedCount = data.failedAssets?.length || 0;
    const totalCount = selectedAssets.length;

    if (data.failedAssets && data.failedAssets.length > 0) {
      if (totalCount === 1 && failedCount === 1) {
        // Check if the error contains "is hosted on Pics.io system storage" for size limit
        const errorMessage = data.failedAssets[0].error;
        if (errorMessage && errorMessage.includes('is hosted on Pics.io system storage')) {
          Toast(localization.TOAST.PUBLISH_CDN_SIZE_LIMIT, { type: 'error' });
        } else {
          Toast(localization.TOAST.PUBLISH_CDN_ERROR, { type: 'error' });
        }
      } else {
        // Multiple assets with partial success - some assets published, some failed
        Toast(localization.TOAST.PUBLISH_CDN_PARTIAL_SUCCESS(failedCount, totalCount), { type: 'error' });
      }
      dispatch({ type: TYPES.ASSETS.CDN.PUBLISH.FAILED, error: data.failedAssets[0].error });
    } else {
      // All assets published successfully
      Toast(localization.TOAST.PUBLISH_CDN_SUCCESS(selectedAssets.length), { type: 'success' });
      dispatch({
        type: TYPES.ASSETS.CDN.PUBLISH.COMPLETE,
        payload: {
          assetIds: selectedAssets,
          data: data.publishedAssets || [],
          aggregatedData: {
            ...selectedAssetsAggregatedData,
            selectedAssetsWithCdnLinks: publishedCount || 0,
          },
        },
      });
    }
  } catch (error) {
    const errorStatus = utils.getStatusFromResponceError(error);
    const { BULK_CDN_PUBLISH_LIMIT } = localization.DIALOGS;

    if (errorStatus === 409) {
      showDialog({
        title: BULK_CDN_PUBLISH_LIMIT.title,
        text: BULK_CDN_PUBLISH_LIMIT.text,
        textBtnOk: BULK_CDN_PUBLISH_LIMIT.textBtnCancel,
        textBtnCancel: null,
        onOk: null,
      });
    } else if (errorStatus === 413) {
      // File size exceeds limit
      Toast(localization.TOAST.PUBLISH_CDN_SIZE_LIMIT, { type: 'error' });
    } else {
      Toast(localization.TOAST.PUBLISH_CDN_ERROR, { type: 'error' });
    }

    dispatch({ type: TYPES.ASSETS.CDN.PUBLISH.FAILED, error });
    Logger.error(new Error('Can not publish assets to cdn'), { error }, [
      'PublishToCdntFailed',
      {
        errorMessage: (error && error.message) || 'NoMessage',
      },
    ]);
  }
};
export default publishToCdn;
